// react-native-web's Alert.alert is a no-op stub (it never shows anything),
// so web builds need their own implementation -- window.confirm() blocks
// synchronously and returns a boolean, which we just wrap in a promise to
// match the native signature. confirmLabel/destructive have no web
// equivalent (window.confirm always shows plain OK/Cancel), so they're
// accepted for type parity with confirm.ts but otherwise unused.
export function confirmAsync(options: {
  title: string;
  message?: string;
  confirmLabel?: string;
  destructive?: boolean;
}): Promise<boolean> {
  const text = options.message
    ? `${options.title}\n\n${options.message}`
    : options.title;
  return Promise.resolve(window.confirm(text));
}
